import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

export default function QRScanner({ onScan }) {
  const [scanning, setScanning] = useState(false);
  const [error, setError] = useState('');
  const html5QrRef = useRef(null);
  const mountedRef = useRef(true);
  const scannedRef = useRef(false);

  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
      if (html5QrRef.current && html5QrRef.current.isScanning) {
        html5QrRef.current.stop().catch(() => {});
      }
    };
  }, []);

  const startScanner = async () => {
    setError('');
    scannedRef.current = false;
    try {
      html5QrRef.current = new Html5Qrcode('qr-reader');
      await html5QrRef.current.start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 250, height: 250 } },
        (decodedText) => {
          if (scannedRef.current || !mountedRef.current) return;
          try {
            const parsed = JSON.parse(decodedText);
            // Validar estructura nueva (visitantes array) o antigua (visitante_nombre)
            const tieneVisitantes = parsed.visitantes && parsed.visitantes.length > 0;
            const tieneVisitanteLegacy = parsed.visitante_nombre;
            if (parsed.token && (tieneVisitantes || tieneVisitanteLegacy)) {
              scannedRef.current = true;
              // Detener cámara primero, luego notificar
              if (html5QrRef.current) {
                html5QrRef.current.stop().then(() => {
                  if (mountedRef.current) {
                    setScanning(false);
                    onScan(parsed);
                  }
                }).catch(() => {
                  if (mountedRef.current) {
                    setScanning(false);
                    onScan(parsed);
                  }
                });
              }
            }
          } catch (e) {
            if (mountedRef.current) {
              setError('QR no válido para este sistema');
            }
          }
        },
        () => {} // ignore scan errors
      );
      if (mountedRef.current) setScanning(true);
    } catch (err) {
      if (mountedRef.current) {
        setError('No se pudo acceder a la cámara. Verifica los permisos.');
      }
    }
  };

  const stopScanner = () => {
    if (html5QrRef.current) {
      html5QrRef.current.stop().then(() => {
        if (mountedRef.current) setScanning(false);
      }).catch(() => {
        if (mountedRef.current) setScanning(false);
      });
    }
  };

  return (
    <div className="scanner-container">
      <div id="qr-reader" style={{ width: '100%', borderRadius: 'var(--radius)', overflow: 'hidden', minHeight: scanning ? '300px' : '0' }} />
      {error && <div className="alert alert-error mt-16">⚠️ {error}</div>}
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        {!scanning ? (
          <button className="btn btn-primary btn-full" onClick={startScanner}>
            📷 Activar Cámara
          </button>
        ) : (
          <button className="btn btn-outline btn-full" onClick={stopScanner}>
            ⏹️ Detener Escáner
          </button>
        )}
      </div>
    </div>
  );
}